module.exports = __webpack_public_path__ + "img/drinks.0f81959.jpg";